import type { ReactNode } from 'react'
import { useLocale } from '../i18n'
import { StatusChip } from './StatusChip'

/**
 * D7: something the app is built for but that is not live yet (no keys, no
 * provider, no reader), in one word wherever it shows: CLAUDE.md asks for a
 * visible PENDING state, and the counter reads Italian, not a code word.
 */
export function PendingBadge() {
  const { messages: m } = useLocale()
  return <StatusChip tone="info">{m.app.notActiveYet}</StatusChip>
}

/** The badge, then what is not live and what to do meanwhile. */
export function PendingLine({ children }: { children: ReactNode }) {
  return (
    <p className="flex flex-wrap items-center gap-2">
      <PendingBadge />
      <span>{children}</span>
    </p>
  )
}
